import { useState, useCallback, useEffect, useRef } from 'react';

import movieEmojis from './emojis/movies';
import gameEmojis from './emojis/games';
import proverbEmojis from './emojis/proverbs';
import dishEmojis from './emojis/dish';
import tvShowEmojis from './emojis/tvShows';
import musicGenreEmojis from './emojis/musicGenres';
import bookEmojis from './emojis/books';

import { WhatsappShareButton, WhatsappIcon } from 'react-share';
import { EmailShareButton, EmailIcon } from 'react-share';
import Modal from 'react-modal';
import './App.css';
import './App-dark.css';
import OctoOcto from './OCTOOCTO.png';

Modal.setAppElement('#root') // This line is important for accessibility reasons.

function App() {
  const [emoji, setEmoji] = useState("");
  const [movie, setMovie] = useState("");
  const [answer, setAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [count, setCount] = useState(0);
  const [gameMode, setGameMode] = useState("Mix");
  const answerRef = useRef(null);
  const [currentCategory, setCurrentCategory] = useState("Movie");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const usedIndices = useRef(new Set());
  const [hint, setHint] = useState("");

  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleDarkModeChange = (e) => {
      document.body.classList.toggle("dark", e.matches);
    };
    darkModeMediaQuery.addEventListener("change", handleDarkModeChange);

    handleDarkModeChange(darkModeMediaQuery);

    return () => {
      darkModeMediaQuery.removeEventListener("change", handleDarkModeChange);
    };
  }, []);

  const getRandomItem = useCallback(() => {
    let itemEntries;
    if (gameMode === "Movie") {
      itemEntries = Array.from(movieEmojis.entries());
      setCurrentCategory("Movie");
    } else if (gameMode === "Game") {
      itemEntries = Array.from(gameEmojis.entries());
      setCurrentCategory("Game");
    } else if (gameMode === "Dish") {
      itemEntries = Array.from(dishEmojis.entries());
      setCurrentCategory("Dish");
    } else if (gameMode === "Proverb") {
      itemEntries = Array.from(proverbEmojis.entries());
      setCurrentCategory("Proverb");
    } else if (gameMode === "Mix") {
      // Select a random category
      const categories = [
        { name: "Movie", entries: Array.from(movieEmojis.entries()) },
        { name: "Game", entries: Array.from(gameEmojis.entries()) },
        { name: "Dish", entries: Array.from(dishEmojis.entries()) },

        { name: "Movie", entries: Array.from(movieEmojis.entries()) },
        { name: "Game", entries: Array.from(gameEmojis.entries()) },
        { name: "Dish", entries: Array.from(dishEmojis.entries()) },

        { name: "Proverb", entries: Array.from(proverbEmojis.entries()) },
        { name: "Music Genre", entries: Array.from(musicGenreEmojis.entries()) },
        { name: "Book", entries: Array.from(bookEmojis.entries()) },
        { name: "TV Show", entries: Array.from(tvShowEmojis.entries()) },
      ];
      const selectedCategory = categories[Math.floor(Math.random() * categories.length)];
      itemEntries = selectedCategory.entries;
      setCurrentCategory(selectedCategory.name);
    }
    let randomIndex = Math.floor(Math.random() * itemEntries.length);
    while (usedIndices.current.has(randomIndex)) {
      randomIndex = Math.floor(Math.random() * itemEntries.length);
    }
    usedIndices.current.add(randomIndex);

    const [randomItem, randomEmoji] = itemEntries[randomIndex];
    setMovie(randomItem.toLowerCase());
    setEmoji(randomEmoji);
    setMovie(randomItem.toLowerCase());
    setHint(randomItem[0]); // This line sets the hint to the first letter of the answer
  }, [gameMode]);



  const handleSubmitButtonClick = useCallback(() => {
    setAnswer(removeThe(answer));
    setMovie(removeThe(movie));

    const answerWords = answer.split(' ');
    const movieWords = movie.split(' ');

    let matchingWords = answerWords.filter(word => movieWords.includes(word));

    if (matchingWords.length >= 2) {
      setScore((prevScore) => prevScore + 1);
    }
    else if (answer === movie) {
      setScore((prevScore) => prevScore + 1);
    }
    getRandomItem();
    setAnswer("");
    setCount((prevCount) => prevCount + 1);
    answerRef.current.value = '';
  }, [answer, movie, getRandomItem]);

  const handleKeyPress = useCallback((event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmitButtonClick();
    }
  }, [handleSubmitButtonClick]);

  useEffect(() => {
    if (count === 5) {
      // alert("game over, your score is: " + score + "/5");
      setModalIsOpen(true);
      // setGameMode("");
    }
  }, [count, score]);

  function closeModal() {
    setModalIsOpen(false);
    setScore(0);
    setCount(0);
    resetGame();
  }

  useEffect(() => {
    if (gameMode) {
      getRandomItem();
    }
  }, [getRandomItem, gameMode]);

  function removeThe(str) {
    if (str.slice(0, 4) === "The ") {
      return str.slice(4);
    }
    else if (str.slice(0, 4) === "the ") {
      return str.slice(4);
    } else {
      return str;
    }
  }

  // Add this function to reset the game state and go back to the home screen
  const resetGame = useCallback(() => {
    setScore(0);
    setCount(0);
    setHint("");
    setGameMode("");
    usedIndices.current.clear();
  }, []);


  if (!gameMode) {
    return (
      <div className="App">
        <br />
        <br />
        <h1>Guessing Game</h1>
        {/* <br /> */}
        <button className="search-button" onClick={() => setGameMode("Movie")}>Movie</button>
        <button className="search-button" onClick={() => setGameMode("Dish")}>Dish</button>
        <button className="search-button" onClick={() => setGameMode("Mix")}>Mix</button>
        <button className="search-button" onClick={() => setGameMode("Game")}>Game</button>
        <button className="search-button" onClick={() => setGameMode("Proverb")}>Proverb</button>

        <div className="octo-octo-logo">
          <a href="https://octoocto.net">
            <img src={OctoOcto} alt="contact"></img>
          </a>
        </div>

      </div>
    );
  }

  // Update the game interface to include the "Go Back" button
  return (
    <div className="App">
      <div>
        <br />
        <br />
        <h1>Guessing Game ({gameMode === "Mix" ? currentCategory : gameMode})</h1>
        <h2>{emoji}</h2>
        <br />
        <textarea
          className="text-area"
          value={answer || hint.toUpperCase() + ''}
          onChange={(e) => setAnswer(e.target.value.toLowerCase())}
          onKeyDown={handleKeyPress}
          onFocus={(e) => {
            setTimeout(() => {
              requestAnimationFrame(() => {
                // e.target.select();
              });
            }, 0);
            // e.target.placeholder = '';
            // Check if the input field is empty, then set its value to the hint
            if (e.target.value === '') {
              e.target.value = hint.toUpperCase();
            } else {
              // If the input field is not empty, then ensure the first character equals the hint
              e.target.value = hint.toUpperCase() + e.target.value.slice(1);
            }
          }}

          onBlur={(e) => {
            if (e.target.value === '') {
              e.target.placeholder = hint.toUpperCase() + '...';
            }
          }}
          placeholder={hint.toUpperCase() + '...'}
          rows={1}
          maxLength={50}
          ref={answerRef}
        />

        <br />
        <br />
        {/* <br /> */}
        <button className="search-button"
          onClick={resetGame}>Home</button>
        <button className="search-button"
          onClick={handleSubmitButtonClick}>Submit</button>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          className="ReactModal__Content"
          overlayClassName="ReactModal__Overlay"
          contentLabel="Challenge your friends">
          <h2>Your score is: {score}/5</h2>
          <p>Who can beat you in this game?</p>
          <br />
          <div>
            <WhatsappShareButton
              url={'https://emojiguessinggame.com'}
              title={'Hi! I scored ' + score + '/5 in the emoji guessing game. Can you beat me?'}
              separator=""
              className="Demo__some-network__share-button">
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <EmailShareButton
              url={'https://emojiguessinggame.com'}
              subject={'Guessing Game'}
              body={'Hi! I scored ' + score + '/5 in the emoji guessing game. Can you beat me?'}
              className="Demo__some-network__share-button">
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
          <br />
          {/* <br /> */}
          <button className="search-button" onClick={closeModal}>Home</button>
        </Modal>
        <br />
        <br />
        <p>Score: {score}</p>

        <div className="octo-octo-logo">
          <a href="https://octoocto.net">
            <img src={OctoOcto} alt="contact"></img>
          </a>
        </div>

      </div>
    </div>
  );

}

export default App;
